export interface EfficiencyRange {
  min: number;
  max: number;
  color: string;
  label: string;
  statusText: string;
}

export interface SpecialStatus {
  color: string;
  label: string;
  statusText: string;
}

export interface MachineStatusConfig {
  efficiencyRanges: EfficiencyRange[];
  specialStatuses: {
    fault: SpecialStatus;
    manual: SpecialStatus;
    offline: SpecialStatus;
    stopped: SpecialStatus;
  };
  // When true, machine cards that are not running (stopped / fault / offline / manual)
  // blink + highlight on the machines page and show how long they've been stopped.
  // Configured by a superadmin in Settings. Defaults to off.
  highlightStoppedCards?: boolean;
}

export const DEFAULT_MACHINE_STATUS_CONFIG: MachineStatusConfig = {
  efficiencyRanges: [
    { min: 95, max: 100, color: 'rgb(9, 196, 77)', label: 'RUN', statusText: 'Running' },
    { min: 90, max: 95, color: 'rgb(237, 96, 245)', label: 'LOW', statusText: 'Low Efficiency' },
    { min: 61, max: 90, color: '#eab308', label: 'POOR', statusText: 'Poor Efficiency' },
    { min: 0, max: 61, color: '#f59e0b', label: 'PROB', statusText: 'Problem' },
  ],
  specialStatuses: {
    fault: { color: '#DA3633', label: 'FAULT', statusText: 'Fault' },
    manual: { color: '#004b9d', label: 'MAN', statusText: 'Manual' },
    offline: { color: '#334155', label: 'OFF', statusText: 'Offline' },
    stopped: { color: '#DC2626', label: 'STOP', statusText: 'Stopped' },
  },
  highlightStoppedCards: false,
};
